import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken } from '../../../Utils/restUtils';
import { Search, Filter } from '../../../Constant';
import { useForm } from 'react-hook-form';
import { getAgentCollectionList, getAgentCollectionListRole } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import Transparentspinner from '../../Common/Loader/Transparentspinner';

const AgentCollectionList = () => {
    const { register, handleSubmit } = useForm({});
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };
    const [agentLists, setAgentList] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });

    const AgentColumns = [
        {
            name: <H4>Sl.No</H4>,
            selector: row => row.Si,
            width: '75px',
            center: true,
        },

        {
            name: <H4>Agent Name</H4>,
            id: 'agent_name',
            selector: row => row.agent_name,
            sortable: true,
        },
        {
            name: <H4>Total Collected Amount</H4>,
            id: 'total_collected_amount',
            selector: row => row.total_collected_amount,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Total Received Amount</H4>,
            id: 'total_received_amount',
            selector: row => row.total_received_amount,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Balance Amount</H4>,
            id: 'balance_amount',
            selector: row => row.balance_amount,
            sortable: true,
            center: true,
        },
    ];

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchAgent(currentPage, perPage, filters.search, column.id, newOrder);
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };



    const fetchAgent = async (page, size = perPage, searchKey = '', sortBy = '', sortOrder = '') => {
        setLoading(true);
        const baseUrl = authState.userRole === 1 ? getAgentCollectionList : getAgentCollectionListRole;
        const response = await getClientUrlDataToken(authState.apiUrl, baseUrl +
            `?page=${page}&page_length=${size}&search=${searchKey}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setAgentList(response.data.data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    agent_name: e.agent_name,
                    total_collected_amount: e.total_collected_amount,
                    total_received_amount: e.total_received_amount,
                    balance_amount: e.balance_amount,
                    id: e.id,
                };
            }));
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchAgent(1);
        localStorage.setItem('newOpen2', false)

    }, []);

    const handlePageChange = page => {
        fetchAgent(page, perPage, filters.search, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchAgent(page, newPerPage, filters.search, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const onSubmit = async (data) => {
        const search = data.search;
        setFilters({
            search,
        });
        fetchAgent(1, perPage, search);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle="Agent Payments" parent="Billing" title="Agent Payments" />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-5px 0 -20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>Agent Payments</H3>
                    <div>
                        {(authState.userRole === 1 || authState?.permissions?.includes('store-collection-received')) && (
                            <Link to={`${process.env.PUBLIC_URL}/billing/collect-agent-payment`} className="btn btn-primary">Receive Payment</Link>
                        )}
                    </div>
                </CardHeader>
                <CardBody>
                    <span className='custom-span'>

                        <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                            <Row className="ps-3 mb-4 custom-search-filter align-items-center">
                                <Col xs="6" sm="4" md="2" lg="2">
                                    <input className="form-control" placeholder={Search} type="text"
                                        {...register('search')} />
                                </Col>

                                <Col xs="6" sm="6" md="4" lg="3">
                                    <Btn className="custom-filter-btn" attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={AgentColumns}
                            data={agentLists}
                            onSort={handleSort}
                            sortServer
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default AgentCollectionList;